import slugify from "slugify";

export function slugifyKey(value: string, fallback: string, options?: { maxLength?: number; replacement?: string }): string {
  const replacement = options?.replacement ?? "_";
  const normalized = slugify(value, {
    lower: true,
    replacement,
    strict: true,
    trim: true,
  }).slice(0, options?.maxLength ?? 48);

  return normalized || fallback;
}
